<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <div>
            <label class="label-input">Content</label>
            <ckeditor :editor="editor" v-model="fields.dataContent.content" :config="editorConfig" />
          </div>
          <v-row>
            <v-col cols="12">
              <div class="mt-10">
                <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                  <label for="backgroundImageEnable" style="margin-bottom: 0" class="font-weight-bold"
                    >Background Image</label
                  >
                  <input type="checkbox" v-model="fields.backgroundImage.enable" id="backgroundImageEnable" />
                </div>
              </div>
              <UploadImage
                v-if="fields.backgroundImage.enable"
                @callback="handleUploadBackgroundImage"
                :image="{ imageSrc: fields.backgroundImage.image }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveBackgroundImage"
              />
              <div v-if="fields.backgroundImage.enable" class="mt-5">
                <div class="d-flex align-center mb-4">
                  <label for="overlayShow" class="mb-0 mr-2">Overlay opacity</label>
                  <input type="checkbox" v-model="fields.overlay.enable" id="overlayShow" />
                </div>
                <v-slider
                  v-if="fields.overlay.enable"
                  v-model="fields.overlay.opacity"
                  class="align-center"
                  :step="0.1"
                  :max="1"
                  :min="0"
                  hide-details
                  thumb-label="always"
                >
                </v-slider>
              </div>
              <div v-if="!fields.backgroundImage.enable" class="d-flex align-center gap-3 mt-5">
                <input
                  type="color"
                  name="background-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.backgroundColor"
                  @change="handleChangeBackgroundColor"
                />
                <v-text-field v-model="fields.backgroundColor" label="Background Color" />
                <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-7">
          <div class="d-flex align-center mb-4">
            <label for="imageShow" class="label-input mb-0 mr-2">Image</label>
            <input type="checkbox" v-model="fields.dataImg.enable" id="imageShow" />
          </div>
          <v-select
            v-if="fields.dataImg.enable"
            :value="fields.dataImg.order"
            :items="postionOptions"
            label="Position"
            @change="handleChangePosition"
          />
          <div>
            <UploadImage
              v-if="fields.dataImg.enable"
              @callback="handleUploadImage"
              :image="{ imageSrc: fields.dataImg.image }"
              :height="`250`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveUpload"
            />
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding</label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'card-freesize-img-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        backgroundColor: '',
        topPadding: true,
        bottomPadding: true,
        backgroundImage: {
          enable: false,
          image: '',
        },
        overlay: {
          enable: false,
          opacity: 0.2,
        },
        dataImg: {
          order: 1,
          image: '',
          enable: true,
        },
        dataContent: {
          order: 2,
          content: '',
        },
      },
      postionOptions: [
        {
          text: 'Left',
          value: 1,
        },
        {
          text: 'Right',
          value: 2,
        },
      ],
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  watch: {
    'fields.backgroundImage.enable'(newVal) {
      if (!newVal) {
        // Tự động tắt overlay khi tắt background image
        this.fields.overlay.enable = false;
      }
    },
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardFeeSizeImg(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },

    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields.backgroundColor = '#ffffff';
    },
    handleUploadBackgroundImage(obj) {
      this.fields.backgroundImage.image = obj.imageSrc;
      this.fields.backgroundImage.enable = true;
    },
    handleRemoveBackgroundImage() {
      this.fields.backgroundImage.image = '';
      this.fields.backgroundImage.enable = false;
      // Tự động tắt overlay khi xóa background image
      this.fields.overlay.enable = false;
    },

    handleUploadImage(obj) {
      this.fields.dataImg.image = obj.imageSrc;
    },
    handleRemoveUpload() {
      this.fields.dataImg.image = '';
    },
    handleChangePosition(value) {
      this.fields.dataImg.order = Number(value);
      if (value === 1) {
        this.fields.dataContent.order = 2;
      } else {
        this.fields.dataContent.order = 1;
      }
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
